/**
 * Display-gating filter used by Go Fetch's two-stage server-page handoff (#332).
 *
 * Constrains a dbView's lokiView to the `_id`s that view's own stage-2 server fetch(es)
 * returned, accumulated across pages on `dbView.gateResultIds`. The gate is keyed to the
 * view's own result set rather than a shared `meta.forTempQueryResult` record tag, so two
 * dbViews over the same relation can't clobber each other's gate (#898). This mirrors how
 * `fullTextSearch.getMql` gates server search results via `{ _id: { $in: serverResults } }`.
 *
 * (The `meta.forTempQueryResult` record tag is still written by
 * `fetchAndUpsertTemporaryQueryResult` and `fullTextSearch.preFilter` — but only for
 * truncation/eviction protection, ADR-GF-001, not for display gating.)
 *
 * Intentionally exports only `getMql` — no `getUriComponent` and no `preFilter`.
 * Without `getUriComponent` it cannot reach the server URL via `getQueryUrl`.
 * Without `preFilter` it does not trigger a server round-trip.
 *
 * Applied via `viewCriteria.applyFilters({ forTempQueryResult: dbView.gateResultIds }, GATE_FILTER_ID)`
 * by `dbViews/getNextPageFromServer` after each server page lands.
 */
export const GATE_FILTER_ID = '__forTempQueryResultGate__';

export default {
    getMql
};

function getMql(filters) {
    const ids = filters?.forTempQueryResult;
    // ids is this view's accumulated server-result _ids. Guard against a non-array or empty
    // list: an `$in: []` would match nothing and blank the view, so emit no gate instead
    // (callers only apply the gate once a fetch has returned ids, but stay defensive).
    if (!Array.isArray(ids) || ids.length === 0) return;
    return { _id: { $in: ids } };
}
